// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> weidner-apartment-homes-theme-comfy -> cypress-pointe
// Generated: 2026-11-04T21:30:03.820Z
// Counts: 0 design, 38 content, 23 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Spacious Living Options</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome To <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Midland Neighborhood Awaits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1><h1></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Cypress Pointe in Midland, TX, you'll enjoy a host of amenities both in your apartment and around the community. Inside, every home comes with central AC and heating, spacious walk-in closets, and a separate dining area. Select apartments offer features such as vaulted ceilings, a wood-burning fireplace, built-in bookshelves, and a private patio or balcony. Step outside to enjoy an outdoor pool with two separate wading pools, a playground, courtyard, open carport parking, laundry facilities, and smoke-free living. Professional on-site management and 24-hour emergency maintenance give you peace of mind every day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Connect with the Cypress Pointe Apartments team in Midland, TX. Whether you have questions about floor plans, leasing, or scheduling a tour, our leasing professionals are here to help you take the next step toward your new home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover a mix of studio, one, and two bedroom apartment homes at Cypress Pointe in Midland, TX. With layouts designed for comfort and flexibility, each floor plan features walk-in closets and central AC. Whether you're looking for a sunlit work-from-home space or extra storage, you'll find an option that fits your needs and lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Studio, one, and two bedrooms designed for you in Midland</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Picture yourself living at Cypress Pointe Apartments in Midland, TX. Browse our gallery to see bright, open-concept living areas, relaxing bedrooms, and community social spaces. Enjoy views of our outdoor pool, playground, and inviting courtyards. Every image captures the comfortable lifestyle and sense of community you'll find at Cypress Pointe.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Comfort and community in the heart of Midland, TX</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Cypress Pointe puts you near everything that makes Midland, TX, special. Grab coffee or a bite at local favorites, unwind at nearby Grafa Park, or take advantage of easy access to Centennial Park, Walmart, and the Permian Basin Petroleum Museum. With Highways 250, 191, and 158 all around, getting to Midland Memorial Hospital West Campus, top employers, or a night out is never a hassle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover apartments for rent in Midland, TX, at Cypress Pointe - where everyday moments feel warm and welcoming. Here, pet-friendly living meets comfort with elegant touches and useful amenities, including an inviting pool, playground, and cozy fireplace options. Enjoy a vibrant community that brings neighbors together in the friendly Lilly Heights neighborhood, just minutes from downtown.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose your perfect tour option at Cypress Pointe Apartments in Midland, TX. Schedule a private in-person walkthrough with our leasing team or book a live virtual tour for a personalized online experience. No matter your preference, we make it easy to see our studio, one-bedroom, and two-bedroom apartments, plus explore community features like the pool and playground. Touring restrictions may apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With a virtual tour of Cypress Pointe Apartments in Midland, TX, you can walk through spacious layouts and community spaces right from home. Explore the features and atmosphere at your own pace and get an inside look at what everyday life could feel like. Whether you're planning a move or just browsing, online touring helps you picture your future with comfort and ease.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "customValue": "/apply-now",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "footer.get_in_touch_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "future-residents-club-hero.bg_image": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[2].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[2].image_media.alt_text"
      }
    }
  },
  "hero.feature_slide_1": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "hero.feature_slide_2": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "hero.feature_slide_4": {
    "sourceIndex": 0,
    "fieldOverrides": null
  },
  "hero.feature_slide_5": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0221-f993-7751-9dd4-82ccb0f290dd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with fireplace, desk, and couch."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0222-239b-7218-bc53-9b90380d3b62.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Private balcony with two chairs and a small table at Cypress Pointe."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0222-1765-770d-896c-5b1d0f29da11.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool with lounge chairs and a building in the background."
      }
    }
  },
  "residentaccess.payrent_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0221-f993-7751-9dd4-7bf4ff4feadf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with white refrigerator, wooden cabinets, and a double sink."
      }
    }
  },
  "residentaccess.portal_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0222-06a9-74d8-b641-40058883f27c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Cozy bedroom featuring a queen-size bed with plush bedding, nightstand with lamp, and a decorative wall art."
      }
    }
  },
  "residentaccess.service_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0221-faaa-737c-b1bb-419bec9f8220.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with fireplace and open kitchen bar."
      }
    }
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
